module.exports = __webpack_public_path__ + "static/img/info_stage4.73da15c.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/info_stage4.png
// module id = Ta8P
// module chunks = 1